module.exports = __webpack_public_path__ + "static/media/mentorship.d8522714.svg";